import logisticRoutesService from "../shared/services/logisticRoutesService";

const REQUEST_LOGISTIC_ROUTES = "REQUEST_LOGISTIC_ROUTES";
const RESPONSE_LOGISTIC_ROUTES = "RESPONSE_LOGISTIC_ROUTES";
const REQUEST_LOGISTIC_ROUTES_FAILURE = "REQUEST_LOGISTIC_ROUTES_FAILURE";

const requestLogisticRoutesAction = () => {
  return {
    type: REQUEST_LOGISTIC_ROUTES,
  };
};

const responseLogisticRoutesAction = (data) => {
  return {
    type: RESPONSE_LOGISTIC_ROUTES,
    data,
  };
};

const requestLogisticRoutesFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_ROUTES_FAILURE,
    errors,
  };
};

const getLogisticRoutes = (options = {}) => {
  return (dispatch) => {
    dispatch(requestLogisticRoutesAction());

    options.orderBy = "title";

    logisticRoutesService
      .getLogisticRoutes(options)
      .then((result) => {
        dispatch(responseLogisticRoutesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestLogisticRoutesFailureAction(error.response));
      });
  };
};

const REQUEST_LOGISTIC_ROUTE = "REQUEST_LOGISTIC_ROUTE";
const RESPONSE_LOGISTIC_ROUTE = "RESPONSE_LOGISTIC_ROUTE";
const REQUEST_LOGISTIC_ROUTE_FAILURE = "REQUEST_LOGISTIC_ROUTE_FAILURE";

const requestLogisticRouteAction = () => {
  return {
    type: REQUEST_LOGISTIC_ROUTE,
  };
};

const responseLogisticRouteAction = (data) => {
  return {
    type: RESPONSE_LOGISTIC_ROUTE,
    data,
  };
};

const requestLogisticRouteFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_ROUTE_FAILURE,
    errors,
  };
};

const getLogisticRoute = (options) => {
  return (dispatch) => {
    dispatch(requestLogisticRouteAction());

    logisticRoutesService
      .getLogisticRoute(options)
      .then((result) => {
        dispatch(responseLogisticRouteAction(result.data));
      })
      .catch((error) => {
        dispatch(requestLogisticRouteFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_LOGISTIC_ROUTE = "REQUEST_CREATE_LOGISTIC_ROUTE";
const RESPONSE_CREATE_LOGISTIC_ROUTE = "RESPONSE_CREATE_LOGISTIC_ROUTE";
const REQUEST_CREATE_LOGISTIC_ROUTE_FAILURE = "REQUEST_CREATE_LOGISTIC_ROUTE_FAILURE";

const requestCreateLogisticRouteAction = () => {
  return {
    type: REQUEST_CREATE_LOGISTIC_ROUTE,
  };
};

const responseCreateLogisticRouteAction = (data) => {
  return {
    type: RESPONSE_CREATE_LOGISTIC_ROUTE,
    data,
  };
};

const requestCreateLogisticRouteFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_LOGISTIC_ROUTE_FAILURE,
    errors,
  };
};

const createLogisticRoute = (options) => {
  return (dispatch) => {
    dispatch(requestCreateLogisticRouteAction());

    logisticRoutesService
      .createLogisticRoute(options)
      .then((result) => {
        options.id = result.data.id;
        dispatch(responseCreateLogisticRouteAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateLogisticRouteFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_LOGISTIC_ROUTE = "REQUEST_DELETE_LOGISTIC_ROUTE";
const RESPONSE_DELETE_LOGISTIC_ROUTE = "RESPONSE_DELETE_LOGISTIC_ROUTE";
const REQUEST_DELETE_LOGISTIC_ROUTE_FAILURE = "REQUEST_DELETE_LOGISTIC_ROUTE_FAILURE";

const requestDeleteLogisticRouteAction = () => {
  return {
    type: REQUEST_DELETE_LOGISTIC_ROUTE,
  };
};

const responseDeleteLogisticRouteAction = (data) => {
  return {
    type: RESPONSE_DELETE_LOGISTIC_ROUTE,
    data,
  };
};

const requestDeleteLogisticRouteFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_LOGISTIC_ROUTE_FAILURE,
    errors,
  };
};

const deleteLogisticRoute = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteLogisticRouteAction());

    logisticRoutesService
      .deleteLogisticRoute(options)
      .then((result) => {
        dispatch(responseDeleteLogisticRouteAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteLogisticRouteFailureAction(error.response));
      });
  };
};

const ON_SELECT_LOGISTIC_ROUTE = "ON_SELECT_LOGISTIC_ROUTE";

const onSelectLogisticRouteAction = (data) => {
  return {
    type: ON_SELECT_LOGISTIC_ROUTE,
    data,
  };
};

const selectLogisticRoute = (data) => {
  return (dispatch) => {
    dispatch(onSelectLogisticRouteAction(data));
  };
};

const REQUEST_UPDATE_LOGISTIC_ROUTE = "REQUEST_UPDATE_LOGISTIC_ROUTE";
const RESPONSE_UPDATE_LOGISTIC_ROUTE = "RESPONSE_UPDATE_LOGISTIC_ROUTE";
const REQUEST_UPDATE_LOGISTIC_ROUTE_FAILURE = "REQUEST_UPDATE_LOGISTIC_ROUTE_FAILURE";

const requestUpdateLogisticRouteAction = () => {
  return {
    type: REQUEST_UPDATE_LOGISTIC_ROUTE,
  };
};

const responseUpdateLogisticRouteAction = (data) => {
  return {
    type: RESPONSE_UPDATE_LOGISTIC_ROUTE,
    data,
  };
};

const requestUpdateLogisticRouteFailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_LOGISTIC_ROUTE_FAILURE,
    errors,
  };
};

const updateLogisticRoute = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateLogisticRouteAction());

    logisticRoutesService
      .updateLogisticRoute({ id: options.id, title: options.title, description: options.description })
      .then((result) => {
        dispatch(responseUpdateLogisticRouteAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateLogisticRouteFailureAction(error.response));
      });
  };
};

const REQUEST_ADD_CONTROL_POINT_ROUTE = "REQUEST_ADD_CONTROL_POINT_ROUTE";
const RESPONSE_ADD_CONTROL_POINT_ROUTE = " RESPONSE_ADD_CONTROL_POINT_ROUTE";
const REQUEST_ADD_CONTROL_POINT_ROUTE_FAILURE = "REQUEST_ADD_CONTROL_POINT_ROUTE_FAILURE";

const requestAddControlPointRouteAction = () => {
  return {
    type: REQUEST_ADD_CONTROL_POINT_ROUTE,
  };
};

const responseAddControlPointRouteAction = (data) => {
  return {
    type: RESPONSE_ADD_CONTROL_POINT_ROUTE,
    data,
  };
};

const requestAddControlPointRouteFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_CONTROL_POINT_ROUTE_FAILURE,
    errors,
  };
};

const addControlPointRoute = (routeId, controlPoint) => {
  return (dispatch) => {
    dispatch(requestAddControlPointRouteAction());

    logisticRoutesService
      .addControlPointRoute({ routeId: routeId, controlPointId: controlPoint.id })
      .then((result) => {
        dispatch(responseAddControlPointRouteAction(controlPoint));
      })
      .catch((error) => {
        dispatch(requestAddControlPointRouteFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_CONTROL_POINT_ROUTE = "REQUEST_DELETE_CONTROL_POINT_ROUTE";
const RESPONSE_DELETE_CONTROL_POINT_ROUTE = " RESPONSE_DELETE_CONTROL_POINT_ROUTE";
const REQUEST_DELETE_CONTROL_POINT_ROUTE_FAILURE = "REQUEST_DELETE_CONTROL_POINT_ROUTE_FAILURE";

const requestDeleteControlPointRouteAction = () => {
  return {
    type: REQUEST_DELETE_CONTROL_POINT_ROUTE,
  };
};

const responseDeleteControlPointRouteAction = (controlPointId) => {
  return {
    type: RESPONSE_DELETE_CONTROL_POINT_ROUTE,
    controlPointId,
  };
};

const requestDeleteControlPointRouteFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_CONTROL_POINT_ROUTE_FAILURE,
    errors,
  };
};

const deleteControlPointRoute = (routeId, controlPointId) => {
  return (dispatch) => {
    dispatch(requestDeleteControlPointRouteAction());

    logisticRoutesService
      .deleteControlPointRoute({ routeId: routeId, controlPointId: controlPointId })
      .then((result) => {
        dispatch(responseDeleteControlPointRouteAction(controlPointId));
      })
      .catch((error) => {
        dispatch(requestDeleteControlPointRouteFailureAction(error.response));
      });
  };
};

const REQUEST_LOGISTIC_ROUTE_GEOJSON = "REQUEST_LOGISTIC_ROUTE_GEOJSON";
const RESPONSE_LOGISTIC_ROUTE_GEOJSON = "RESPONSE_LOGISTIC_ROUTE_GEOJSON";
const REQUEST_LOGISTIC_ROUTE_GEOJSON_FAILURE = "REQUEST_LOGISTIC_ROUTE_GEOJSON_FAILURE";

const requestLogisticRouteGeoJsonAction = () => {
  return {
    type: REQUEST_LOGISTIC_ROUTE_GEOJSON,
  };
};

const responseLogisticRouteGeoJsonAction = (data) => {
  return {
    type: RESPONSE_LOGISTIC_ROUTE_GEOJSON,
    data,
  };
};

const requestLogisticRouteGeoJsonFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_ROUTE_GEOJSON_FAILURE,
    errors,
  };
};

const getLogisticRouteGeoJson = (options) => {
  return (dispatch) => {
    dispatch(requestLogisticRouteGeoJsonAction());

    logisticRoutesService
      .getLogisticRouteGeoJson(options)
      .then((result) => {
        dispatch(responseLogisticRouteGeoJsonAction(result.data));
      })
      .catch((error) => {
        dispatch(requestLogisticRouteGeoJsonFailureAction(error.response));
      });
  };
};

const REQUEST_SETNUMBER_CONTROL_POINT_ROUTE = "REQUEST_SETNUMBER_CONTROL_POINT_ROUTE";
const RESPONSE_SETNUMBER_CONTROL_POINT_ROUTE = " RESPONSE_SETNUMBER_CONTROL_POINT_ROUTE";
const REQUEST_SETNUMBER_CONTROL_POINT_ROUTE_FAILURE = "REQUEST_SETNUMBER_CONTROL_POINT_ROUTE_FAILURE";

const requestSetNumberControlPointRouteAction = () => {
  return {
    type: REQUEST_SETNUMBER_CONTROL_POINT_ROUTE,
  };
};

const responseSetNumberControlPointRouteAction = (data) => {
  return {
    type: RESPONSE_SETNUMBER_CONTROL_POINT_ROUTE,
    data,
  };
};

const requestSetNumberControlPointRouteFailureAction = (errors) => {
  return {
    type: REQUEST_SETNUMBER_CONTROL_POINT_ROUTE_FAILURE,
    errors,
  };
};

const setNumberControlPointRoute = (options) => {
  return (dispatch) => {
    dispatch(requestSetNumberControlPointRouteAction());

    logisticRoutesService
      .setNumberControlPointRoute(options)
      .then((result) => {
        dispatch(responseSetNumberControlPointRouteAction(result.data));
      })
      .catch((error) => {
        dispatch(requestSetNumberControlPointRouteFailureAction(error.response));
      });
  };
};

export {
  REQUEST_LOGISTIC_ROUTES,
  RESPONSE_LOGISTIC_ROUTES,
  REQUEST_LOGISTIC_ROUTES_FAILURE,
  getLogisticRoutes,
  REQUEST_LOGISTIC_ROUTE,
  RESPONSE_LOGISTIC_ROUTE,
  REQUEST_LOGISTIC_ROUTE_FAILURE,
  getLogisticRoute,
  REQUEST_CREATE_LOGISTIC_ROUTE,
  RESPONSE_CREATE_LOGISTIC_ROUTE,
  REQUEST_CREATE_LOGISTIC_ROUTE_FAILURE,
  createLogisticRoute,
  REQUEST_DELETE_LOGISTIC_ROUTE,
  RESPONSE_DELETE_LOGISTIC_ROUTE,
  REQUEST_DELETE_LOGISTIC_ROUTE_FAILURE,
  deleteLogisticRoute,
  ON_SELECT_LOGISTIC_ROUTE,
  selectLogisticRoute,
  REQUEST_UPDATE_LOGISTIC_ROUTE,
  RESPONSE_UPDATE_LOGISTIC_ROUTE,
  REQUEST_UPDATE_LOGISTIC_ROUTE_FAILURE,
  updateLogisticRoute,
  REQUEST_ADD_CONTROL_POINT_ROUTE,
  RESPONSE_ADD_CONTROL_POINT_ROUTE,
  REQUEST_ADD_CONTROL_POINT_ROUTE_FAILURE,
  addControlPointRoute,
  REQUEST_DELETE_CONTROL_POINT_ROUTE,
  RESPONSE_DELETE_CONTROL_POINT_ROUTE,
  REQUEST_DELETE_CONTROL_POINT_ROUTE_FAILURE,
  deleteControlPointRoute,
  REQUEST_LOGISTIC_ROUTE_GEOJSON,
  RESPONSE_LOGISTIC_ROUTE_GEOJSON,
  REQUEST_LOGISTIC_ROUTE_GEOJSON_FAILURE,
  getLogisticRouteGeoJson,
  REQUEST_SETNUMBER_CONTROL_POINT_ROUTE,
  RESPONSE_SETNUMBER_CONTROL_POINT_ROUTE,
  REQUEST_SETNUMBER_CONTROL_POINT_ROUTE_FAILURE,
  setNumberControlPointRoute,
};
